import personal from './personal.js'
import other from './other.js'
import system from './system.js'
import org from './org.js'
import settle from './settle.js'
import contract from './contract.js'
import resource from './resource.js'
import org_index from './org_index.js'
import org_personal from './org_personal.js'

var api = {}

api = Object.assign(api, personal, other, system, org, settle, contract, resource, org_index, org_personal)

export default api
